import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import DashboardSpaceShowView from "./dashboard_space-show.html";


angular.module("dashboard_space", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('dashboard_space', {
                url: "/dashboard_space",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })
            .state('dashboard_space.show', {
                url: "/show/:id/:spaceId",
                controller: "DashboardSpaceShowCtrl",
                template: DashboardSpaceShowView
            })
        ;
    }])
;